module.exports = __webpack_public_path__ + "static/media/blog.76410c8d.svg";